import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import LoadingDialog from "../../components/loadingDialog";

type Props = {
    open: boolean;
    message: React.ReactNode;
    loading?: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
};

export default function PrConfirmDialog({open, message, loading, onClose, onConfirm}: Props) {
    const handleClose = (_event?: any, reason?: any) => {
        if (reason === "backdropClick" || loading) {
            return;
        }
        onClose();
    };

    if (!open) {
        return null;
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            {loading ? <LoadingDialog/> : (
                <DialogActions>
                    <Button sx={{color: "red"}} onClick={onClose}>No</Button>
                    <Button sx={{color: "green"}} onClick={onConfirm} autoFocus>Yes</Button>
                </DialogActions>
            )}
        </Dialog>
    );
}
